import React, { useId, useState } from 'react';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { matchValue, statisticNumber } from '../utils/matchRecord';
import './matchRecord/MatchRecord.css';

const PERIODS = ['total', 'primeraParte', 'segundaParte'];

export default function MatchStatistics({ estadisticas, equipoLocal, equipoVisitante, escudoLocal, escudoVisitante }) {
  const { t } = useTranslation('matches');
  const theme = useTheme();
  const id = useId();
  const available = PERIODS.filter(key => Array.isArray(estadisticas?.[key]) && estadisticas[key].length);
  const [selected, setSelected] = useState('total');
  const period = available.includes(selected) ? selected : available[0];
  const groups = new Map();
  (estadisticas?.[period] || []).filter(row => row && typeof row === 'object').forEach(row => {
    const category = row.categoria || t('record.otherStatistics');
    if (!groups.has(category)) groups.set(category, []);
    groups.get(category).push(row);
  });
  if (!available.length) return null;
  return <div className="mr-statistics" data-theme={theme.palette.mode}>
    <header className="mr-stat-header">
      <div className="mr-team-legend"><span>{escudoLocal && <img src={escudoLocal} alt="" />}{equipoLocal}</span>
        <span>{equipoVisitante}{escudoVisitante && <img src={escudoVisitante} alt="" />}</span></div>
      <div className="mr-segmented" role="group" aria-label={t('record.period')}>
        {available.map(key => <button type="button" key={key} aria-pressed={key === period} onClick={() => setSelected(key)}>
          {t(`record.periods.${key}`)}</button>)}
      </div>
      <p className="mr-help">{t('record.statisticsHelp')}</p>
    </header>
    {[...groups].map(([category, statistics], groupIndex) => <section className="mr-panel mr-stat-category" key={category}
      aria-labelledby={`${id}-${groupIndex}`}>
      <h3 id={`${id}-${groupIndex}`}>{category}</h3>
      <table aria-label={`${category} · ${t(`record.periods.${period}`)}`}>
        <thead className="mr-sr-only"><tr><th scope="col">{equipoLocal}</th><th scope="col">{t('record.metric')}</th>
          <th scope="col">{equipoVisitante}</th></tr></thead>
        {statistics.map((statistic, index) => {
          const home = statisticNumber(statistic.porcentajeLocal) ?? statisticNumber(statistic.local);
          const away = statisticNumber(statistic.porcentajeVisitante) ?? statisticNumber(statistic.visitante);
          const maximum = home !== null && away !== null && home >= 0 && away >= 0 ? Math.max(home, away) : 0;
          return <tbody key={`${statistic.nombre}-${index}`}><tr className="mr-stat-values">
            <td><strong className={matchValue(statistic.local).length > 8 ? 'mr-stat-compound' : undefined}>{matchValue(statistic.local)}</strong>
              {statistic.porcentajeLocal !== undefined && statistic.porcentajeLocal !== '' && <small>{matchValue(statistic.porcentajeLocal)}</small>}</td>
            <th scope="row">{statistic.nombre}</th>
            <td><strong className={matchValue(statistic.visitante).length > 8 ? 'mr-stat-compound' : undefined}>{matchValue(statistic.visitante)}</strong>
              {statistic.porcentajeVisitante !== undefined && statistic.porcentajeVisitante !== '' && <small>{matchValue(statistic.porcentajeVisitante)}</small>}</td>
          </tr><tr aria-hidden="true"><td colSpan={3} className="mr-stat-track-cell">
            <div className="mr-stat-track"><div>{maximum > 0 && <span style={{ width: `${home / maximum * 100}%` }} />}</div>
              <div>{maximum > 0 && <span style={{ width: `${away / maximum * 100}%` }} />}</div></div>
          </td></tr></tbody>;
        })}
      </table>
    </section>)}
  </div>;
}
